import { createSlice } from "@reduxjs/toolkit";

export const LifestyleSlice = createSlice({
  name: "Lifestyle",
  initialState: {
    entries: [],
    recommendations: [],
    config: {},
    loading: false,
    error: null,
  },
  reducers: {
    GetLifestyleEntries: (state) => {
      state.loading = true;
    },
    SetLifestyleEntries: (state, action) => {
      state.entries = action.payload;
      state.loading = false;
    },
    AddLifestyleEntry: (state) => {
      state.loading = true;
    },
    AddLifestyleEntrySuccess: (state, action) => {
      state.entries = [action.payload, ...state.entries];
      state.loading = false;
    },
    GetDietRecommendations: (state) => {
      state.loading = true;
    },
    SetDietRecommendations: (state, action) => {
      state.recommendations = action.payload;
      state.loading = false;
    },
    SetLifestyleError: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    DeleteLifestyleEntry: (state) => {
      state.loading = true;
    },
    GetLifestyleConfig: (state) => {
      state.loading = true;
    },
    SetLifestyleConfig: (state, action) => {
      state.config = action.payload;
      state.loading = false;
    }
  },
});

export const { 
    GetLifestyleEntries, 
    SetLifestyleEntries, 
    AddLifestyleEntry, 
    AddLifestyleEntrySuccess,
    GetDietRecommendations,
    SetDietRecommendations,
    SetLifestyleError,
    DeleteLifestyleEntry,
    GetLifestyleConfig,
    SetLifestyleConfig
} = LifestyleSlice.actions;

export default LifestyleSlice.reducer;
